import { Link } from 'gatsby';
import React, { useContext } from 'react';
import { useLocation } from '@reach/router'; // eslint-disable-line
import PropTypes from 'prop-types';
import { NavContext } from './NavContext';
import NavBarCollapsible from './NavBarCollapsible';
import useMediaQuery from '../hooks/useMediaQuery';

LandingHeader.propTypes = {
  blog: PropTypes.bool.isRequired,
  mobileBlog: PropTypes.bool.isRequired,
};

function LandingHeader({ blog, mobileBlog }) {
  // const { pathname } = useLocation();
  const { mobileMenu, mobileMenuClick, setMobileMenu } = useContext(NavContext);
  const isHamburgerNav = useMediaQuery(`(max-width: 1200px)`);
  const links = (
    <ul>
      <li>
        <Link onClick={() => setMobileMenu(false)} to="/phoenix-copilot">
          Phoenix &quot;AI&quot; Copilot
        </Link>
      </li>
      {isHamburgerNav ? (
        <NavBarCollapsible
          name="phoenix"
          label="Phoenix"
          to="/phoenix"
          defaultOpen={false}>
          <Link to="/phoenix-copilot" onClick={() => setMobileMenu(false)}>
            Phoenix &quot;AI&quot; Copilot
          </Link>
          <Link to="/probuild" onClick={() => setMobileMenu(false)}>
            Phoenix Pro Build
          </Link>
          <Link to="/python-build" onClick={() => setMobileMenu(false)}>
            Phoenix Python Build
          </Link>
        </NavBarCollapsible>
      ) : (
        <li key="phoenix" className="dropdown open">
          <Link to="/phoenix" className="dropdown-toggle">
            Phoenix
          </Link>
          <div className="dropdown-menu">
            <Link to="/phoenix-copilot">Phoenix &quot;AI&quot; Copilot</Link>
            <Link to="/probuild">Phoenix Pro Build</Link>
            <Link to="/python-build">Phoenix Python Build</Link>
          </div>
        </li>
      )}
      <li>
        <Link to="/odyssey">Odyssey</Link>
      </li>
      <li>
        <Link to="/enterprise">Enterprise</Link>
      </li>
      <li>
        <Link to="/pricing">Pricing</Link>
      </li>
      <li>
        <Link to="/quant-quest">Quant Quest</Link>
      </li>
      {isHamburgerNav ? (
        <NavBarCollapsible
          name="resources"
          label="Resources"
          defaultOpen={false}>
          <Link to="/blog" onClick={() => setMobileMenu(false)}>
            Blogs
          </Link>
          <Link to="/help" onClick={() => setMobileMenu(false)}>
            Help
          </Link>
        </NavBarCollapsible>
      ) : (
        <li key="resources" className="dropdown open">
          <button
            type="button"
            onClick={(e) => e.preventDefault()} // Prevent dropdown toggle action
            className="dropdown-toggle">
            Resources
          </button>
          <div className="dropdown-menu">
            <Link to="/blog">Blogs</Link>
            <Link to="/help">Help</Link>
          </div>
        </li>
      )}
    </ul>
  );
  if (mobileBlog) {
    return links;
  }
  const linksContainer = (
    <div style={{ zIndex: '99999' }} className="main-nav">
      {links}
    </div>
  );
  if (blog) return linksContainer;

  return (
    <div
      style={{ zIndex: '999' }}
      className={mobileMenu ? 'menu-main menu-open' : 'menu-main'}>
      <span
        label="none"
        className="hamburger"
        role="button"
        tabIndex="0"
        onClick={mobileMenuClick}
        onKeyDown={mobileMenuClick}
        aria-label="hamburger-button">
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </span>
      {linksContainer}
    </div>
  );
}

export default LandingHeader;

// {
//   /* <div className="dropdown-menu">
//         <a
//           href="https://app.algobulls.com/marketplace/category/retail"
//           target="_blank"
//           rel="noopener noreferrer">
//           <span>
//             <img src="/img/marketplace-icon.svg" alt="" />
//           </span>
//           Retail Marketplace
//         </a>
//         <a
//           href="https://app.algobulls.com/marketplace/category/premium"
//           target="_blank"
//           rel="noopener noreferrer">
//           <span>
//             <img
//               src="/img/marketplace-icon.svg"
//               style={{ transform: 'rotateZ(270deg)' }}
//               alt=""
//             />
//           </span>
//           Premium Marketplace
//         </a>
//         <a
//           href="https://app.algobulls.com/marketplace/category/hni"
//           target="_blank"
//           rel="noopener noreferrer">
//           <span>
//             <img
//               src="/img/marketplace-icon.svg"
//               style={{ transform: 'rotateZ(180deg)' }}
//               alt=""
//             />
//           </span>
//           HNI Marketplace
//         </a>
//         {/*
//         <a
//           href="https://app.algobulls.com/marketplace/category/ultrahni"
//           target="_blank"
//           rel="noopener noreferrer">
//           <span>
//             <img
//               src="/img/marketplace-icon.svg"
//               style={{ transform: 'rotateZ(90deg)' }}
//               alt=""
//             />
//           </span>
//           Ultra HNI Marketplace
//         </a>
//         *
//         {/*
//         <a
//           href="https://app.algobulls.com/marketplace/category/institutional"
//           target="_blank"
//           rel="noopener noreferrer">
//           <span>
//             <img src="/img/ins-marketplace-icon.svg" alt="" />
//           </span>
//           Institution Marketplace
//         </a>
//         *
//       </div> */
// }
